<div class="registration-wizard-disabled step-container">
    <p class="display-message">{{ displayMessage$ | async }}</p>
    <button
        id="back-to-login"
        class="btn"
        [attr.aria-label]="'registration.wizard.disabled.page.login.button.screenreader' | translate : { fgbdefault: 'Back to Login Page' }"
        (click)="navigateToLoginPage()">{{ 'fgbcl.registration.wizard.disabled.page.login.button' | translate }}
    </button>
    
</div>
